import Icon from '../components/Icon.vue'

Icon.register({
  'caret-down': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M31.3 192H288.6C306.4 192 315.3 213.5 302.7 226.1L174.1 354.8C166.3 362.6 153.6 362.6 145.8 354.8L17.2 226.1C4.6 213.5 13.5 192 31.3 192z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/caret-down.js
// module id = TFdi
// module chunks = 144